import { capitalizeFirst, isNull } from "App/utils/helpers";
import { useDispatchWrapper } from "hooks";
import React, { useCallback, useRef } from "react";
import { useEffect } from "react";
import {
  changeActiveTab,
  changeLoading,
  changeTabs,
  resetPageProps,
} from "./context/actions";
import { initialStatePageProps } from "./context/state";
import WrapperTabItem from "./WrapperTabItem";
import {
  arrayMove,
  SortableContainer,
  SortableElement,
} from "react-sortable-hoc";
import styled from "@emotion/styled";
import { DragIndicator } from "@material-ui/icons";
import { useStylesWrapperTab } from "./WrapperThemeProvider";

export const ListItem = styled.span`
  letter-spacing: 0.035rem;
  text-transform: uppercase;
`;

export const SortableComponent = styled.div`
  font-family: sans-serif;
`;

export const RemoveListItem = styled.button`
  appearance: none;
  border: 0;
  font-size: 0.6rem;
  -webkit-appearance: none;
  border-radius: 0px 5px 5px 0px;
  background: transparent;
  font-family: "Poppins", sans-serif;
`;

export const ClickListItem = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  font-size: 0.6rem;
  -webkit-appearance: none;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  ${"" /* color:#fff; */}
`;

export const MoveListItem = styled.button`
  border: 0;
  font-size: 0.6rem;
  border-radius: 6px;
  background: transparent;
  margin-top: 3px;
  ${"" /* color:#ffffff; */}
  ${"" /* color:#a5a5a5; */}
  cursor: move;
`;

export const SortableListContainer = styled.div`
  display: flex;
  height: auto;
  flex-wrap: wrap;
  padding: 0;
  user-select: none;
  width: 100%;
  -webkit-overflow-scrolling: touch;
`;

export const SortableListItem = styled.div`
  cursor: move;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;

function WrapperTab({ tabs, handleClickRemoveTab, handleClickTab, active }) {
  const tabRef = useRef();

  const { state, dispatch } = useDispatchWrapper();
  const themeList = state.theme_list;

  const classes = useStylesWrapperTab();

  const handleCloseAll = () => {
    dispatch(changeActiveTab([]));
    dispatch(changeTabs([]));
    dispatch(resetPageProps(initialStatePageProps));
    dispatch(changeLoading(false));
  };

  const handleCloseOther = () => {
    let newTabs = [];
    tabs?.map((item) => item.code === active && newTabs.push(item));
    dispatch(changeActiveTab(state.wrapper_active_tab));
    dispatch(changeTabs(newTabs));
    dispatch(changeLoading(false));
  };

  const handleScroll = useCallback(() => {
    const y = window.scrollY;
    if (!isNull(tabRef.current)) {
      if (y >= 50) {
        tabRef.current.style.position = "sticky";
        tabRef.current.style.padding = "0.4rem 0.8rem 0.8rem 0.8rem";
        tabRef.current.style.marginLeft = 0;
        tabRef.current.style.background = isNull(themeList?.header)
          ? "#FFF"
          : themeList?.header;
        tabRef.current.style.zIndex = "3";
        tabRef.current.style.top = "0";
        tabRef.current.style.boxShadow = "0px 0px 10px rgba(0, 0, 0, 0.2)";
      } else {
        tabRef.current.style.position = "flex";
        tabRef.current.style.padding = "0";
        tabRef.current.style.marginLeft = "0.8rem";
        tabRef.current.style.boxShadow = "0px 0px 0px rgba(0, 0, 0, 0)";
        tabRef.current.style.background = "transparent";
        tabRef.current.style.zIndex = "1";
      }
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    document.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []); // eslint-disable-line

  const onSortEnd = ({ oldIndex, newIndex }) => {
    dispatch(changeTabs(arrayMove(state.wrapper_tabs, oldIndex, newIndex)));
  };

  const SortableItem = SortableElement(
    ({ value, code, name, handleClickRemoveTab, handleClickTab, active }) => (
      <SortableListItem
        className={`${classes.tabMenu_item} ${
          active === code ? classes.active : ""
        } `}>
        <div className={classes.tabMenu_item_menu_wrapper}>
          <MoveListItem>
            <DragIndicator />
          </MoveListItem>

          <ClickListItem
            className={classes.tabMenu_item_menu}
            onClick={() => handleClickTab(code)}>
            {capitalizeFirst(name)}
          </ClickListItem>
          <RemoveListItem
            className={classes.tabMenu_item_icon}
            onClick={() => handleClickRemoveTab(code)}>
            X
          </RemoveListItem>
        </div>
        <ListItem>{value}</ListItem>
      </SortableListItem>
    )
  );

  const SortableList = SortableContainer(({ items }) => (
    <SortableListContainer>
      <WrapperTabItem
        name={"Tutup semua"}
        code={"_tutup_semua"}
        handleClickRemoveTab={handleClickRemoveTab}
        handleClickTab={handleCloseAll}
        hasClose={false}
        classes={classes}
      />
      <WrapperTabItem
        name={"Tutup Selain"}
        code={"_tutup_selain"}
        handleClickRemoveTab={handleClickRemoveTab}
        handleClickTab={handleCloseOther}
        hasClose={false}
        classes={classes}
      />

      {tabs.map((e, index) => {
        if (e.name !== "" && e.code !== "") {
          return (
            <SortableItem
              index={index}
              key={`item-${index}`}
              name={e.name}
              code={e.code}
              handleClickRemoveTab={handleClickRemoveTab}
              handleClickTab={handleClickTab}
              active={active}
            />
          );
        } else {
          return false;
        }
      })}
    </SortableListContainer>
  ));

  return (
    tabs.length > 0 && (
      <div className='tabs' ref={tabRef}>
        <SortableList axis={"x"} onSortEnd={onSortEnd} />
      </div>
    )
  );
}

export default WrapperTab;
